var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15442 6.45967H16V8.59053H9.15442V15.1844H6.9229V8.59053H0.0605469V6.45967H6.9229V0H9.15442V6.45967Z",
    fill: "#4CC4B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCon);
export default __webpack_public_path__ + "static/media/add-con.fc38206a7d478122a39a0bbe95e759b4.svg";
export { ForwardRef as ReactComponent };